import React, { useEffect, useState } from "react";
import { faCheck, faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../../../Styles/Redirecting Styles/NavbarStyles/Bespoke.css";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { animateScroll as scroll } from "react-scroll";
import Shape2 from "../../../assets/brand/choose-shape-2.png";
import ModalVideo from "react-modal-video";
import "react-modal-video/scss/modal-video.scss";
import { Helmet } from "react-helmet";
import CanadaHeader1 from "../../Components/seperate Components/CanadaHeader1";
import CanadaFooter from "../../Components/Footer";

import beSpokeImg1 from "../../../assets/canada/Bespoke-System/Bes-Sys-sec-1-1.jpg";
import beSpokeImg2 from "../../../assets/canada/Bespoke-System/Bes-Sys-sec-1-2.jpg";
import beSpokeImg3 from "../../../assets/canada/Bespoke-System/Bes-Sys-sec-1-3.jpg";

import beSpokeSolution from "../../../assets/canada/Bespoke-System/Bes-sys-Sec-5.jpg";

import section1 from "../../../assets/canada/custom-software-development/Custom Software 1.jpg";
import section2 from "../../../assets/canada/custom-software-development/Custom Software 2.jpg";
import section3 from "../../../assets/canada/custom-software-development/Custom Software.jpg";

const CanadaBespokeSystem = () => {
  const toggleContact = () => {
    scroll.scrollToTop(0, 0);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [isOpen, setOpen] = useState(false);

  return (
    <div>
      <Helmet>
        <title>Top Custom Software Development Company in USA</title>
        <meta
          name="description"
          content="Experience top custom software development services in USA. CRM, ERP systems, and more - we offer the best software solutions for your business needs."
        />
        <meta
          name="keywords"
          content="custom software development company, custom software development, custom software, custom software USA, custom software solutions USA, best software solutions USA, software development USA, software development company in USA, software development services in USA, top software development companies in USA, custom software development USA, best software development company in USA, software development companies in USA, custom software development company USA, software development company, software development, crm software, crm system, erp system, best erp systems"
        />
      </Helmet>

      <CanadaHeader1 />

      {/* Banner section */}
      <div
        className="bd-page-title-area bd-page-title-bg1 pt-220 pb-155"
        style={{ height: "380px" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div
                className="bd-page-title text-center z-index"
                style={{ bottom: "45px" }}
              >
                <h2
                  className="breadcrumb-title"
                  style={{ fontSize: "50px", color: "#4a026c" }}
                >
                  Custom Software Development
                </h2>
                <div className="breadcrumb-menu">
                  <nav className="breadcrumb-trail breadcrumbs">
                    <p style={{ color: "black" }}>
                      Partnering with a Custom Software Development Firm boosts
                      operational efficiency and drives profitability for
                      companies.
                    </p>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* First Section */}

      <section className="bd-about-area">
        <div className="bd-custom-container">
          <div className="bd-about-four-bg  pt-80 pb-0 fix">
            <div className="bd-about-shape-box">
              <div className="container" style={{ maxWidth: "1270px" }}>
                <div className="row justify-content-center">
                  <div className="col-xl-6 col-lg-8 first_resp_bespoke">
                    <div className="bd-choose-img text-end mb-30 top-resp z-index">
                      <div className="row align-items-center custom-mar-15">
                        <div className="col-xl-6 col-lg-6 col-6 custom-pad-15">
                          <div className="bd-choose-img-inner mb-15 bd-choose-img-inner-1">
                            <img
                              src={'https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1747308456/USA%20website/CUSTOM%20SOFTWARE%20DEVELOPMENT/Custom_Software_3_f8vlm4.png '}
                              className="resp-img bordertop-img1"
                              alt="img not found"
                            />
                          </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-6 custom-pad-15">
                          <div className="bd-choose-img-inner mb-15">
                            <img
                              src={'https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1747308455/USA%20website/CUSTOM%20SOFTWARE%20DEVELOPMENT/Custom_Software_1_uioour.png '}
                              className="resp-img bordertop-img2"
                              alt="img not found"
                            />
                          </div>
                          <div className="bd-choose-img-inner mb-15">
                            <img
                              src={'https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1747308453/USA%20website/CUSTOM%20SOFTWARE%20DEVELOPMENT/Custom_Software_4_lftjsa.png'}
                              className="resp-img bordertop-img3"
                              alt="img not found"
                            />
                          </div>
                        </div>
                      </div>
                      <img
                        className="bd-choose-shape bd-choose-shape-2"
                        src={Shape2}
                        alt="shape img not found"
                      />
                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-8 second_resp_bespoke">
                    <div className="bd-about-text bd-about-text-four mb-40 z-index">
                      <div className="bd-section-title-wrapper">
                        <h2 className="bd-section-title mb-15 md-pr-50">
                          Unlock Success Through
                          <span style={{ color: "#ffbf1e" }}>
                            {" "}
                            Custom Software{" "}
                          </span>
                        </h2>
                        <p className="">
                          In the Canadian landscape, a custom software solution
                          represents the art of precisely tailoring software to
                          your specific needs, ensuring outstanding results.
                          With these customized solutions, you can focus on
                          excelling in your core competencies and effectively
                          navigating your business.
                        </p>
                        <p>
                          Tailor-made systems empower businesses to enhance
                          productivity and strengthen profitability. Partnering
                          with an adept software developer allows businesses to
                          cultivate a personalized solution that precisely
                          aligns with their needs. This enables businesses to
                          focus on their core strengths and reduce disruptions
                          to their overall operations. From improved customer
                          communication to optimized efficiency, custom software
                          systems finely tune the seamless functioning of your
                          business.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <ModalVideo autoplay isOpen={isOpen} channel='youtube' videoId='6wrgJR1n5ao' onClose={() => setOpen(false)}>
                </ModalVideo>
                <button className="btn btn touch_pop_vid first_pop_video_bespoke" onClick={() => setOpen(true)}>
                    <FontAwesomeIcon icon={faPlay} className="play_bt_vid play_transition" />
                </button> */}
      </section>

      {/* <!-- about area start here --> */}
      <section className="bd-about-six-area ">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <h2 className="bd-section-title mb-25 bespoke_section2-tittle">
          Build What Your Business Truly Deserves.
          </h2>
          <div className="row bespoke_responsive">
            <div className="col-lg-6 first_section_responsive ">
              <div className="bd-about-six-text">
                <div className="bd-section-title-wrapper mb-25">
                  <p>
                  Your business isn’t one-size-fits-all—so why should your software be? In a world full of generic tools, we craft custom software built around you. Whether you're streamlining operations or scaling dreams, our solutions are designed to empower your team, reduce daily stress, and keep you focused on what matters most.
                  </p>
                  <p>
                  With our expert developers by your side, you get more than code—you get clarity, connection, and control. From smoother workflows to stronger client experiences, we help you create software that feels like it was always meant to be yours.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-8 second_section_responsive">
              <div className="bd-about-six-img">
                <div className="bd-about-six-feature">
                  <ul className="mb-45">
                    <li
                      style={{
                        fontSize: "18px",
                        color: "var(--clr-body-text)",
                      }}
                    >
                      <i>
                        <FontAwesomeIcon icon={faCheck} />
                      </i>{" "}
                      Individually Crafted Solution
                    </li>
                    <li
                      style={{
                        fontSize: "18px",
                        color: "var(--clr-body-text)",
                      }}
                    >
                      <i>
                        <FontAwesomeIcon icon={faCheck} />
                      </i>{" "}
                      Growth & scalability
                    </li>
                    <li
                      style={{
                        fontSize: "18px",
                        color: "var(--clr-body-text)",
                      }}
                    >
                      <i>
                        <FontAwesomeIcon icon={faCheck} />
                      </i>{" "}
                      Return On Investment
                    </li>
                    <li
                      style={{
                        fontSize: "18px",
                        color: "var(--clr-body-text)",
                      }}
                    >
                      <i>
                        <FontAwesomeIcon icon={faCheck} />
                      </i>{" "}
                      Time-saving
                    </li>
                    <li
                      style={{
                        fontSize: "18px",
                        color: "var(--clr-body-text)",
                      }}
                    >
                      <i>
                        <FontAwesomeIcon icon={faCheck} />
                      </i>{" "}
                      Competitive advantage
                    </li>
                    <li
                      style={{
                        fontSize: "18px",
                        color: "var(--clr-body-text)",
                      }}
                    >
                      <i>
                        <FontAwesomeIcon icon={faCheck} />
                      </i>{" "}
                      No integration issues
                    </li>
                    <li
                      style={{
                        fontSize: "18px",
                        color: "var(--clr-body-text)",
                      }}
                    >
                      <i>
                        <FontAwesomeIcon icon={faCheck} />
                      </i>{" "}
                      Easier maintenance
                    </li>
                    <li
                      style={{
                        fontSize: "18px",
                        color: "var(--clr-body-text)",
                      }}
                    >
                      <i>
                        <FontAwesomeIcon icon={faCheck} />
                      </i>{" "}
                      More independent
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* choose section */}
      <section className="bd-choose-area fix">
        <div className="container" style={{ maxWidth: "1300px" }}>
          <div className="bd-choose-shape pt-70">
            <div className="row four_resp_section">
              <div className="col-xl-6 col-lg-6 order-2 order-lg-1 four_point_section1">
                {/* <div className="ablog ablog-4 mb-60"> */}
                <div className="bd-choose-img z-index pt-70">
                  <div className="bd-choose-info-wrapper">
                    <div className="container text-center">
                      <div className="row mb-50">
                        <div className="col cell_resp mr-30">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440034/website/icons/vertical-scalability-64_hj9kjd.png" />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Scalability and flexibility
                              </h2>
                            </div>
                          </div>
                        </div>
                        <div className="col">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440035/website/icons/ownership-64_iwkti6.png" />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Complete ownership
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="container text-center">
                      <div className="row">
                        <div className="col cell_resp mr-30">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440035/website/icons/integration-64_n7ffaa.png" />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Fast integration
                              </h2>
                            </div>
                          </div>
                        </div>
                        <div className="col respon_space">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440034/website/icons/trophy-64_t3l2yz.png" />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Competitive advantage
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* </div> */}
              </div>
              <div className="col-xl-6 col-lg-6 order-1 order-lg-2 mt-0 four_point_section2">
                <div className="bd-choose-text z-index">
                  <h2 className="bd-section-title section_title2">
                  Empower Your Business with Custom Software That Understands You
                  </h2>
                  <div className="bd-section-title-wrapper">
                    <p style={{ fontSize: "18px", lineHeight: "1.75" }}>
                    In the USA, we create more than just software—we craft solutions that are as unique as your business. We know that behind every decision, every process, and every challenge, there’s a dream and a team working tirelessly to make it happen. That’s why we design software that works for you, not just with you—solutions that enhance efficiency, improve experiences, and make your goals feel more attainable.
                    </p>
                    <p style={{ fontSize: "18px", lineHeight: "1.75" }}>
                    Our team doesn’t just develop software; we listen, understand, and partner with you to create something that truly fits. From smooth workflows to user-friendly interfaces, every line of code is designed to move you closer to your vision. Your success becomes our mission.
                    </p>
                  </div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bd-service-area pb-70 pt-5">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row"></div>
          <div className="row sixth-main-responsive">
            <h2 className="mb-30 sixth-section-soft">
              Tools and Technologies Applied in the Process
            </h2>
            <div className="col-lg-4 col-md-6 sixth-soft-section1">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <p>
                  Some of the commonly used tools in software development are
                  resources like Git, code management systems like GitLab, and
                  build management systems like Jenkins.
                </p>
                <table style={{ marginLeft: "50px" }}>
                  <tbody>
                    <tr style={{ marginBottom: "20px" }}>
                      <td className="pb-30" style={{ width: "180px" }}>
                        <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659616468/website/icons/filezilla_t4bxqw.png" />
                      </td>
                      <td className="pb-30" style={{ width: "180px" }}>
                        <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659616468/website/icons/visual-studio-code_ouivep.png" />
                      </td>
                      <td className="pb-30">
                        <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659616468/website/icons/windows-10_kl8cu2.png" />
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659616468/website/icons/linux-server_p6azlz.png" />
                      </td>
                      <td>
                        <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659616468/website/icons/xcode_hxtmqb.png" />
                      </td>
                      <td>
                        <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659616468/website/icons/postman_bshp0x.png" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 sixth-soft-section1">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <p>
                  Within the realm of business processes, a wide spectrum of
                  technologies is available for utilization. These encompass
                  software development tools, an array of programming languages,
                  and a diverse assortment of application development
                  frameworks.
                </p>
                <table style={{ marginLeft: "50px" }}>
                  <tbody>
                    <tr style={{ marginBottom: "20px" }}>
                      <td className="pb-30" style={{ width: "180px" }}>
                        <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659616446/website/icons/dot-net_rqknrj.png" />
                      </td>
                      <td className="pb-30" style={{ width: "180px" }}>
                        <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659616446/website/icons/angularjs_luxe11.png" />
                      </td>
                      <td className="pb-30">
                        <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659616446/website/icons/nodejs_lab0zs.png" />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659616446/website/icons/flutter_p8yphu.png" />
                      </td>
                      <td>
                        <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659616446/website/icons/php_s2e2xk.png" />
                      </td>
                      <td>
                        <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659616446/website/icons/react_hmd8zn.png" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <ServiceBanner/> */}

      <section
        className="bd-video-area pt-135 pb-130"
        style={{ backgroundColor: "#5c0385" }}
      >
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row">
            <div className="col-lg-12 first_section">
              <div className="bd-video-text">
                <h2 className="bd-video-title first-para-resp">
                Looking for a Custom Software Development Expert in USA?
                </h2>
                <p className="contact_section second-para-resp">
                  You're here at the right moment.
                </p>
                <p className="contact_subtext">
                  Outstanding System, Let's Kickstart Now!
                </p>
              </div>
            </div>
            <div className="col-lg-12 second_section">
              <div className="contact-stuff pt-30">
                <div className="contact_icon pt-15 pl-50">
                  <FontAwesomeIcon
                    icon={faPhone}
                    style={{ fontSize: "30px" }}
                  />
                </div>
                <div className="contact_txt">
                  <p className="contact-sub-text">CALL US NOW</p>
                  <a
                    href="tel:+1 (307) 677-8060"
                    style={{ fontSize: "17px" }}
                    className="mbb-5 pb-20"
                  >
                    +1 (307) 677-8060
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <CanadaFooter />
    </div>
  );
};

export default CanadaBespokeSystem;
